import { render } from "./UpsertTemplateModal.vue?vue&type=template&id=317be7f2"
import script from "./UpsertTemplateModal.vue?vue&type=script&lang=js"
export * from "./UpsertTemplateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__